/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'

import SubHierarcyList from './component/SubHierarcyList'

const SubHierarchyWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{''}</PageTitle>
      <div className='card mb-5 mb-xl-10'>
        <SubHierarcyList></SubHierarcyList>
      </div>
    </>
  )
}

export {SubHierarchyWrapper}
